import { configureStore } from '@reduxjs/toolkit'

// reducers
import roomsReducer from "./slices/roomsSlice"

export const store = configureStore({
  reducer: {
    rooms: roomsReducer
  },
})